import ActionType from './action-type'
import * as Actions from './actions'
import {type ThunkAction} from 'redux-thunk'
import {type AppState} from '../../types/app-state'
import {type LocationTagArrayMapType} from './state'
import {Api} from '../../../api/Api'
import {type GuidType} from '../../../values/generic-type-defintions'
import {fetchLocations} from '../locations/action-creators'
import {type LocationIdType} from '../locations/state'
import {
    getAllVesselTags,
    getAllLocationTagsByLocation,
    createVesselTag,
    type CreateVesselTagReq,
    type AssignVesselToTagReq,
    unassignVesselTag,
    updateVesselTag,
    type VesselTagResponse,
    type VesselTag,
    type UpdateVesselTagReq,
} from '../../../api/vessels/vessel-tags'

export const VESSEL_TAGS_REST_URL = '/vessels/api/v1/locationTags'

export function fetchAllLocationTagsByLocation(): ThunkAction<void, AppState, Api, Actions.Action> {
    return (dispatch): void => {
        dispatch(requestVesselTagsAction())

        getAllLocationTagsByLocation()
            .then((response) => {
                dispatch(receiveVesselTagsByLocationAction(new Map(Object.entries(response.data))))
            }) // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/use-unknown-in-catch-callback-variable
            .catch((error) => {
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                dispatch(setErrorMessage(error?.response?.data as ErrorObject))
                dispatch(
                    receiveVesselTagsByLocationAction(
                        new Map<LocationIdType, VesselTagResponse[]>(),
                    ),
                )
            })

        getAllVesselTags()
            .then((response) => {
                dispatch(receiveVesselTagsAction(response.data))
            }) // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/use-unknown-in-catch-callback-variable
            .catch((error) => {
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                dispatch(setErrorMessage(error?.response?.data as ErrorObject))
                dispatch(receiveVesselTagsAction(new Array<VesselTag>()))
            })
    }
}

function requestVesselTagsAction(): Actions.RequestAllLocationTagsByLocationAction {
    return {
        type: ActionType.REQUEST_ALL_LOCATION_TAGS_BY_LOCATION,
    }
}

function receiveVesselTagsByLocationAction(
    vesselTagsByLocation: LocationTagArrayMapType,
): Actions.ReceiveAllLocationTagsByLocationAction {
    return {
        type: ActionType.RECEIVE_ALL_LOCATION_TAGS_BY_LOCATION,
        payload: vesselTagsByLocation,
    }
}

function receiveVesselTagsAction(vesselTags: VesselTag[]): Actions.ReceiveTagsAction {
    return {
        type: ActionType.RECEIVE_ALL_TAGS,
        payload: vesselTags,
    }
}

export function setTagToCreateOrAssign(
    tagToCreateOrAssign: CreateVesselTagReq | AssignVesselToTagReq | null,
): Actions.SetTagToCreateOrAssignAction {
    return {
        type: ActionType.SET_TAG_TO_CREATE_OR_ASSIGN,
        payload: tagToCreateOrAssign,
    }
}

export function createOrAssignLocationTag(
    tagToCreateOrAssign: CreateVesselTagReq | AssignVesselToTagReq,
): ThunkAction<void, AppState, Api, Actions.Action> {
    return (dispatch) => {
        createVesselTag(tagToCreateOrAssign)
            .then(() => {
                dispatch(fetchAllLocationTagsByLocation())
                dispatch(fetchLocations(false))
                dispatch(setTagToCreateOrAssign(null))
                dispatch(setSearchTerm(''))
            }) // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/use-unknown-in-catch-callback-variable
            .catch((error) => {
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                dispatch(setErrorMessage(error?.response?.data as ErrorObject))
                setTimeout(() => dispatch(setErrorMessage(undefined)), 5000)
            })
    }
}

export function deleteLocationTag(
    locationIdentity: GuidType,
    tagIdentityToDelete: GuidType,
): ThunkAction<void, AppState, Api, Actions.Action> {
    return (dispatch) => {
        unassignVesselTag({
            locationIdentity: locationIdentity,
            locationTagIdentity: tagIdentityToDelete,
        })
            .then(() => {
                dispatch(fetchAllLocationTagsByLocation())
                dispatch(fetchLocations(false))
                dispatch(setTagToUpdate(null))
            }) // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/use-unknown-in-catch-callback-variable
            .catch((error) => {
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                dispatch(setErrorMessage(error?.response?.data as ErrorObject))
                setTimeout(() => dispatch(setErrorMessage(undefined)), 5000)
            })
    }
}
export function setErrorMessage(message: ErrorObject | undefined): Actions.SetErrorResultAction {
    return {
        type: ActionType.SET_ERROR_RESULT,
        payload: message,
    }
}

export function setSearchTerm(searchedTerm: string): Actions.SetSearchTermAction {
    return {
        type: ActionType.SET_SEARCH_TERM,
        payload: searchedTerm,
    }
}

export function setTagToUpdate(
    tagToUpdate: UpdateVesselTagReq | null,
): Actions.SetTagToUpdateAction {
    return {
        type: ActionType.SET_TAG_TO_UPDATE,
        payload: tagToUpdate,
    }
}

export function updateLocationTag(
    tagToUpdate: UpdateVesselTagReq,
): ThunkAction<void, AppState, Api, Actions.Action> {
    return (dispatch) => {
        updateVesselTag(tagToUpdate)
            .then(() => {
                dispatch(fetchAllLocationTagsByLocation())
                dispatch(setTagToUpdate(null))
                dispatch(setSearchTerm(''))
            }) // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/use-unknown-in-catch-callback-variable
            .catch((error) => {
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                dispatch(setErrorMessage(error?.response?.data as ErrorObject))
                setTimeout(() => dispatch(setErrorMessage(undefined)), 5000)
            })
    }
}
export type ErrorObject = Record<'error', Record<string, string>>
